import Vue from 'vue';
import VeeValidate, { Validator } from "vee-validate";
import vi from 'vee-validate/dist/locale/vi';

import App from './App.vue';
import router from './Router';
import store from './store'
import './Library';
import {captchaCompare} from './config'

Vue.config.productionTip = false;

Vue.use(VeeValidate, {
  events: "input|changed"
});
Validator.localize('vi', vi);
captchaCompare(Validator);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
